import React, { FC, useCallback, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { useDispatch } from 'react-redux'
import { Spacer } from 'components/Utility'
import { Description, MainHeadline } from 'components/Typography'
import { BusinessHourCard, BusinessHourHelp } from 'components/Card'
import { openModal } from 'reducks/modal/operations'
import { ShoppingBagCard } from 'components/ShoppingBag'
import { NavButton } from 'components/Button'
import { initStore } from 'reducks/store/operations'
import { push } from 'connected-react-router'
import { initConfirm, updateEditState } from 'reducks/confirm/operations'

type Props = {
  isAdmin?: boolean
  storeId?: string
}

const AccountSettingsTemplate: FC<Props> = (props) => {
  const { isAdmin, storeId } = props

  const dispatch = useDispatch()

  const openBusinessHourHelp = useCallback(() => {
    dispatch(openModal(<BusinessHourHelp />, 'sacri上の営業時間について'))
  }, [dispatch])

  // 営業時間・定休日に遷移したらstoreをrefetchするため
  useEffect(() => {
    dispatch(updateEditState(false))
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline
        headline={'sacri上の営業時間・定休日'}
        iconPath={'/icon/blue/help.svg'}
        onClick={openBusinessHourHelp}
      />
      <Spacer size={20} />
      <BusinessHourCard isAdmin={isAdmin} storeId={storeId} />
      <Spacer size={48} />
      <MainHeadline headline={'レジ袋オプション'} />
      <Spacer size={12} />
      <Description description={'お客さまが商品と一緒に購入できるレジ袋についての設定です。'} />
      <Spacer size={20} />
      <ShoppingBagCard isAdmin={isAdmin} storeId={storeId} />
      <Spacer size={48} />
      {isAdmin ? (
        <NavButton
          label={'トップページに戻る'}
          iconPath={'/icon/grey/home.svg'}
          onClick={() => {
            dispatch(initConfirm())
            dispatch(initStore())
            dispatch(push('/admin/shops'))
          }}
          url={'/'}
        />
      ) : (
        <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      )}
      <Spacer size={72} />
    </div>
  )
}

export default AccountSettingsTemplate
